export default "__VITE_ASSET__DfX_86d2__"